var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classesInput},[_c('select',_vm._g(_vm._b({staticClass:"dropdown",domProps:{"value":_vm.internalValue}},'select',_vm.$attrs,false),{
      ..._vm.$listeners,
      input: event => _vm.$emit('input', event.target.value)
    }),[(!!_vm.label)?_c('option',{domProps:{"selected":!_vm.internalValue,"value":null}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._l((_vm.items),function(item){return _c('option',{key:item[_vm.itemValue],domProps:{"value":item[_vm.itemValue],"selected":item[_vm.itemValue] === _vm.internalValue}},[_vm._v(_vm._s(item[_vm.itemText]))])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }